var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from "react";

var SvgOil = function SvgOil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 34 19",
    ref: svgRef
  }, _extends({
    width: "1em",
    height: "1em"
  }, props)), React.createElement("title", null, title), React.createElement("defs", null, React.createElement("path", {
    id: "Oil_svg__b",
    d: "M1167.267 705l-.427 1.094 5.478 1.858.427-1.094z"
  }), React.createElement("path", {
    id: "Oil_svg__c",
    d: "M1177.068 715.793c-3.727-.1-4.196-5.593-4.196-5.593l-2.586-.92.404-1.087-3.694-1.316-.404 1.085-2.586-.921-.137.242c-.78-.68-1.869-1.46-2.988-1.865-.887-.32-1.883-.404-2.677.198-.499.381-.853.853-1.043 1.362a2.55 2.55 0 0 0 .18 2.166c.379.672 1.061 1.232 1.997 1.565l.003.002c.8.283 1.588.435 2.29.511l-2.463 4.336 14.775 5.267a763.833 763.833 0 0 0 10.547-3.615c2.89-1.019 4.232-.13 4.232-.13.941-2.533-7.926-1.187-11.654-1.287zm-14.96-5.41a9.38 9.38 0 0 1-2.46-.498c-1.533-.569-1.982-1.665-1.643-2.606.128-.344.371-.68.752-.97.43-.335 1.05-.335 1.817-.065 1.008.353 2.119 1.172 2.848 1.826z"
  }), React.createElement("path", {
    id: "Oil_svg__a",
    d: "M1186.95 718.65h3.413v5.053h-3.413z"
  }), React.createElement("path", {
    id: "Oil_svg__e",
    d: "M1188.656 718.65c.318 1.471 1.707 1.71 1.707 3.382 0 .935-.764 1.67-1.707 1.67-.942 0-1.706-.735-1.706-1.67 0-1.672 1.39-1.911 1.706-3.382"
  }), React.createElement("clipPath", {
    id: "Oil_svg__d"
  }, React.createElement("use", {
    xlinkHref: "#Oil_svg__a"
  }))), React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#Oil_svg__b",
    transform: "translate(-1157 -705)"
  }), React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#Oil_svg__c",
    transform: "translate(-1157 -705)"
  }), React.createElement("g", {
    clipPath: "url(#Oil_svg__d)",
    transform: "translate(-1157 -705)"
  }, React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#Oil_svg__e"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOil, _extends({
    svgRef: ref
  }, props));
});
export default ForwardRef;